module.exports = __webpack_public_path__ + "assets/img/dzh-10.a0e2b224.jpg";